import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * <wrb-variant-sync data-sync-id="...">
 * Re-renders its children when Horizon's variant picker fetches the section for a new variant.
 * Same pattern as Horizon's product-inventory.js: listen for productSelect on the closest section,
 * then morph our children from the matching element in the returned HTML.
 */
class WrbVariantSync extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const next = detail.html.querySelector(`wrb-variant-sync[data-sync-id="${this.dataset.syncId}"]`);
        if (!next) return;

        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[wrb-variant-sync]', error);
      });
  };
}

if (!customElements.get('wrb-variant-sync')) {
  customElements.define('wrb-variant-sync', WrbVariantSync);
}
